import React from "react";
import { GiftIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { bonuses } from "../../data/content";
export function Bonuses() {
  return <section className="w-full bg-cream py-16 sm:px-4 sm:py-20" aria-label="Exclusive bonuses" data-id="element-90" data-mp="1clzc0idd4o2w">
      <div className="mx-auto max-w-4xl" data-id="element-91" data-mp="18kvxbz71wy39">
        <div className="px-4 sm:px-0" data-id="element-92" data-mp="18hrmwk2zt645">
          <div className="mb-4 flex justify-center" data-id="element-93" data-mp="25a3mdh6vppbx">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-alert text-white" data-id="element-94" data-mp="257hdne8953s4">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-95" data-mp="208xmmzesx1sw" />
            </span>
          </div>
          <SectionHeading title={<>5 exclusive bonuses — <em className="text-cta" data-id="element-97" data-mp="1r9ankk9jo830">free today</em></>} subtitle="Included with your Decision Lab™ at no additional cost." data-id="element-96" data-mp="1wazxfwl16fpi" />
        </div>

        <div className="space-y-8" data-id="element-98" data-mp="fv6xvq9zp63r">
          {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white shadow-sm sm:rounded-3xl sm:ring-1 sm:ring-navy/10" data-id="element-99" data-mp="fx9uwu9k7zhz">
              <div className="flex items-center justify-between gap-3 bg-navy px-4 py-3 sm:px-6" data-id="element-100" data-mp="1jshs34k9kq49">
                <span className="rounded-md bg-gold px-2.5 py-1 text-sm font-extrabold uppercase text-navy-deep" data-id="element-101" data-mp="15t8m0xprvce0">Bonus #{b.number}</span>
                <span className="text-sm font-semibold text-white/80" data-id="element-102" data-mp="1aqqms0tmylax">
                  Value: <s className="text-white/60" data-id="element-103" data-mp="w2x6edwq7era">${b.value}</s>
                </span>
              </div>
              <img src={b.image} alt={`${b.title} bonus mockup`} className="block w-full" loading="lazy" data-id="element-104" data-mp="10u5l9pgtrsbu" />
              <div className="px-5 pb-6 pt-2 sm:px-8" data-id="element-105" data-mp="n3ii9l417g9y">
                <h3 className="font-serif text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-106" data-mp="r42fspsiolwm">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-ink/80" data-id="element-107" data-mp="d4kz6xpdkeyc">{b.desc}</p>
                <div className="mt-5 flex items-center gap-3" data-id="element-108" data-mp="i3ecap0r23xz">
                  <span className="text-lg font-semibold text-muted line-through" data-id="element-109" data-mp="i2uvxcqqznm2">${b.value}</span>
                  <span className="rounded-lg bg-cta px-3 py-1 text-lg font-extrabold uppercase text-white" data-id="element-110" data-mp="2ju4py6s7uyfq">Free</span>
                </div>
              </div>
            </article>)}
        </div>

        <div className="px-4 sm:px-0" data-id="element-111" data-mp="2b0hwwofe89a8">
          <CtaButton label="I want all 5 bonuses" className="mt-10" data-id="element-112" data-mp="261f5i6sc61kq" />
        </div>
      </div>
    </section>;
}